import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SUB_DIRECTORY } from "../../../../common/constant";
// import Blog from "../../../../component/blog";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import SocialMedia from "../../../../component/social_media";
import $ from "jquery";
import _ from 'lodash';
import { actionClientList, resetClientListResponse } from "../my_profile/store";
import { useForm } from "react-hook-form";
import ErrorLabel from "../../../../component/error_label";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import { actionAddEnquiry, resetEnquiryAddResponse } from "./store";
import InfromationCard from "../../../../component/information_card";

const Enquiries = () => {


    const navigation = useNavigate()
    const dispatch = useDispatch()

    const { clientList } = useSelector((state) => ({
        ...state.MyProfileStore
    }))

    const { enquiryAdd } = useSelector((state) => ({
        ...state.enquiryAddStore
    }))

    const [clientListArr, setClientList] = useState([])
    const [selectedEnquiryId, setSelectedEnqueryId] = useState(1)
    const [selectedEnquiryType, setSelectedEnqueryType] = useState('casualty_policy')

    const {
        register,
        formState: { errors },
        handleSubmit, getValues, setValue, watch, control, reset } =
        useForm({
            defaultValues:
            {
            },
        });

    useEffect(() => {
        dispatch(actionClientList())
    }, [])

    const enquery = [
        {
            id: 1,
            title: 'Casualty',
            value: 'casualty_policy',
            image: 'assets/images/casualty_policy.png'
        },
        {
            id: 2,
            title: 'Motor Fleet',
            value: 'motor_fleet_policy',
            image: 'assets/images/motor_fleet_policy.png'
        },
        {
            id: 3,
            title: 'Office Package',
            value: 'office_package_policy',
            image: 'assets/images/office_package_policy.png'
        },
        {
            id: 4,
            title: 'Personal Accident',
            value: 'personal_accident_policy',
            image: 'assets/images/personal_accident_policy.png'
        },
        {
            id: 5,
            title: 'Shopkeeper Package ',
            value: 'shopkeeper_package_policy',
            image: 'assets/images/shopkeeper_package_policy.png'
        },
        {
            id: 6,
            title: 'Financial ',
            value: 'Ffinancial_policy',
            image: 'assets/images/Ffinancial_policy.png'
        },
        {
            id: 7,
            title: 'Group Mediclaim ',
            value: 'group_mediclaim_policy',
            image: 'assets/images/group_mediclaim_policy.png'
        },
        {
            id: 8,
            title: 'Group Travel',
            value: 'group_travel_policy',
            image: 'assets/images/group_travel_policy.png'
        },
        {
            id: 9,
            title: 'Industrial Package',
            value: 'industrial_package_policy',
            image: 'assets/images/industrial_package_policy.png'
        },
        {
            id: 10,
            title: 'Marine Cargo',
            value: 'marine_cargo_policy',
            image: 'assets/images/marine_cargo_policy.png'
        }
    ]

    useEffect(() => {
        if (clientList !== null) {
            dispatch(resetClientListResponse())
            if (clientList.result === true) {
                setClientList(clientList.response)
            } else {
                switch (clientList.status) {
                    default:
                }
            }
        }
    }, [clientList])

    const generateCompanyList = () => {
        var menu = [];
        if (clientListArr != null && clientListArr.length > 0) {
            clientListArr.forEach(function (child, labelIndex) {
                menu.push(
                    <option key={labelIndex} value={child.id}>
                        {child.name}
                    </option>
                );
            });
        }
        return menu;
    };

    useEffect(() => {
        if (enquiryAdd !== null) {
            dispatch(resetEnquiryAddResponse())
            if (enquiryAdd.result === true) {
                $("#save_enquiry-loader").addClass("d-none");
                $("#save_enquiry").prop("disabled", false);
                reset()
                toast.success(enquiryAdd.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
            } else {
                $("#save_enquiry-loader").addClass("d-none");
                $("#save_enquiry").prop("disabled", false);
                switch (enquiryAdd.status_code) {
                    case 400:
                        toast.error(enquiryAdd.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [enquiryAdd])

    const onSubmit = async (data) => {
        var clientId = ''

        if (clientListArr.length > 1) {
            clientId = data.client_id
        } else {
            clientId = clientListArr[0].id

        }
        $("#save_enquiry-loader").removeClass("d-none");
        $("#save_enquiry").prop("disabled", true);
        dispatch(actionAddEnquiry({
            type: selectedEnquiryType,
            message: data.message,
            client_id: clientId
        }))
    }

    return (
        <>

            <div className="row py-5">
                <div class="col-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a>Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Enquiry</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    <div>
                        {/* START: Edit Profile Details */}
                        <div className="mt-2">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <div className="accordion-button-2" type="button">
                                                Enquiry
                                            </div>
                                        </div>
                                    </div>
                                </h2>
                                <div
                                    className="accordion-collapse border-top"
                                    aria-labelledby="panelsStayOpen-headingOne"
                                >
                                    <div className="accordion-body">
                                        <form
                                            noValidate
                                            autoComplete="off"
                                            onSubmit={handleSubmit(
                                                onSubmit
                                            )}>
                                            <div className="row">
                                                {
                                                    enquery != null && enquery.map((item, index) => {
                                                        return (
                                                            <div className="col-md-3" onClick={() => {
                                                                setSelectedEnqueryId(item.id)
                                                                setSelectedEnqueryType(item.value)
                                                            }}>
                                                                <label
                                                                    className={`btn w-100 mb-2 ${selectedEnquiryId === item.id ? 'btn-outline-primary-select' : 'btn-outline-primary'} `}
                                                                    htmlFor="casualty_policy"
                                                                >
                                                                    <img
                                                                        src={item.image}
                                                                        alt=""
                                                                        width="30px"
                                                                    />{" "}
                                                                    <br />
                                                                    {item.title} <br /> Policy
                                                                </label>
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mt-3">
                                                    <label htmlFor="msg" className="form-label">
                                                        Message
                                                    </label>
                                                    <textarea
                                                        rows={3}
                                                        className="form-control"
                                                        id="message"
                                                        {...register(
                                                            "message", {
                                                            required: "This is required.",
                                                            minLength: {
                                                                value: 10,
                                                                message: "Address cannot be less than 10-chars."
                                                            },
                                                            maxLength: {
                                                                value: 500,
                                                                message: "Address cannot be greater than 500-chars."
                                                            },
                                                        }
                                                        )}
                                                    />
                                                    {errors.message && (
                                                        <ErrorLabel
                                                            message={
                                                                errors
                                                                    .message
                                                                    ?.message
                                                            }
                                                        />
                                                    )}
                                                </div>
                                                {
                                                    clientListArr.length > 1 ?
                                                        <div className="col-md-6 mt-3">
                                                            <label htmlFor="company_name" className="form-label">
                                                                Company Name<span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                id="client_id"
                                                                className="form-control form-select"
                                                                {...register(
                                                                    "client_id",
                                                                    {
                                                                        required: "This is required."
                                                                    }
                                                                )}
                                                            >
                                                                <option value="">Company Name</option>
                                                                {generateCompanyList()}
                                                            </select>
                                                            {errors.client_id && (
                                                                <ErrorLabel
                                                                    message={
                                                                        errors
                                                                            .client_id
                                                                            ?.message
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                        :
                                                        <></>
                                                }
                                                <div className="col-md-12 mt-3">
                                                    <button
                                                        id="save_enquiry"
                                                        className="btn btn-primary"
                                                    >Submit
                                                        <span id="save_enquiry-loader" className="spinner-border spinner-border-sm ms-1 d-none"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* END: Edit profile Details */}
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />
                    {/* <Blog /> */}
                </div>
            </div>
        </>

    )

}

export default Enquiries;